<template>
  <StepContainer v-if="schedulingIsEnabled">
    <router-view />

    <template v-slot:alerts>
      <div v-if="showErrors" class="step-controller-errors">
        <BaseAlert
          :hg-lead-in="'Please correct the errors below:'"
          :hg-value="true"
          hg-type="error">
          <div v-for="error in errors.items" :key="error.id">
            {{error.msg}}
          </div>
        </BaseAlert>
      </div>
    </template>

    <template v-slot:sidebar>
      <SummaryPane v-if="summaryPaneVisible" />
    </template>
  </StepContainer>

  <v-container v-else class="core-container">
    <v-layout justify-center>
      <v-flex xs12 md10 lg8>
        <SchedulingUnavailable />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Components } from '@homegauge/vue';
import { mapState, mapGetters } from 'vuex';

import SchedulingUnavailable from '@/components/SchedulingUnavailable.vue';
import StepContainer from '@/components/StepContainer.vue';
import SummaryPane from '@/components/SummaryPane.vue';
import RouteMeta from '@/router/constants/route-meta';
import StepUtilities from '@/router/utilities/step-utilities';

const { BaseAlert } = Components;

export default {
  $_veeValidate: {
    validator: 'new',
  },
  components: {
    BaseAlert,
    SchedulingUnavailable,
    StepContainer,
    SummaryPane,
  },
  props: {
    companyId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      summaryStarted: false,
    };
  },
  provide() {
    return {
      $validator: this.$validator,
    };
  },
  computed: {
    ...mapState('Appointment', [
      'emailComponentData',
      'bookingData',
    ]),
    ...mapGetters('Appointment', [
      'hasTime',
      'hasLocation',
    ]),
    ...mapGetters('Company', [
      'schedulingIsEnabled',
    ]),
    showErrors() {
      return this.errors && this.errors.items.length > 0;
    },
    summaryPaneVisible() {
      return this.$route.meta[RouteMeta.ShowSummarySidebar];
    },
  },
  methods: {
    clickBack() {
      StepUtilities.goToPreviousStep(this.$route, this.$router);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/mixins/breakpoints';
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.step-controller {
  &-content {
    z-index: 1;
  }

  &-controls {
    padding-top: 30px;
    z-index: 2;
  }
}

.mobile-back-container {
  padding: 6px 6px 7px;
}

.back-button {
  align-items: center;
  color: $theme-color-gray;
  display: inline-flex;
  font-size: 1rem;
  font-weight: $typography-weight-semibold;
  font-family: $typography-font-primary;
  letter-spacing: 0.125rem;

   .v-icon {
    color: $theme-color-gray-medium;
    padding-right: 3px;
  }
}

@include responsive-breakpoint(xs) {
  .step-controller {
    padding: 0;
  }
}

@include responsive-breakpoint(sm) {
  .core-container {
    padding-top: 0;
  }

  .step-controller {
    &-container {
      padding-bottom: 5rem;
    }
  }
}

@include responsive-breakpoint(print) {
  .mobile-back-container {
    display: none;
  }
}
</style>
